import React from 'react';

import { DataTable } from "selfly-ui-react";
import moment from 'moment';

import './DeviceDockerTable.scss';

export default function DeviceDockerTable(props)  {

    const { dockers } = props;
    const columns = [
        {
            key: "name",
            header: "Name",
            width: "150px;"
        },
        {
            key: "state",
            header: "State",
            className: "docker-state",
            width: "140px",
            content: (val) => {
                if(val==="running") {
                    return <span className="docker-running">Running</span>;
                }
                return <span className="docker-not-running">Not running</span>
            }
        },
        {
            key: "image",
            header: "Image"
        },
        {
            key: "created",
            header: "Created",
            content: (value) => {
                if(value === null || value === undefined || value === "") return null;
                return moment.unix(value).format("D.M.YYYY HH:mm");
            },
            width: "120px;"
        },
        {
            key: "mem_percent",
            header: "Memory",
            content: (mem_percent, item) => {

                return (`${Number.parseFloat(mem_percent).toFixed(2)} % / ${Math.ceil(item.mem_usage/1000000)}MB`);
            },
            width: "120px;"
        },
        {
            key: "elapsed",
            header: "Elapsed",
            width: "100px;"
        }
    ];

    if(dockers.length === 0) {
        return (<h2 className="no-dockers">No SW instances!</h2>);
    }

    return (
        <DataTable 
            className="device-docker-table"
            data={dockers}
            columns={columns} />
    )
}